import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider, { useAuth } from '../security/security/AuthContext';
import { checkUserRole } from '../security/api/ApiClient';
import Login from '../userDashboard/auth/Login';
import Signup from '../userDashboard/auth/SignUp';
import Auth from '../userDashboard/auth/Auth';
import Home from '../userDashboard/Home';
import Team from '../userDashboard/Team';
import Me from '../userDashboard/Me';
import Order from '../userDashboard/Order';
import Proof from '../userDashboard/Proof';
import VerifyEmail from '../userDashboard/auth/VerifyEmail ';
import { EmailVerificationFailed } from '../userDashboard/auth/EmailVerified';
import { EmailVerified } from '../userDashboard/auth/EmailVerified';
import ForgotPassword from '../userDashboard/auth/ForgotPassword';
import ResetPassword from '../userDashboard/auth/ResetPassword';
import Loading from '../userDashboard/auth/loaders/Loading';
import PrivacyPolicy from '../component/PrivacyPolicy';
import WhatsAppUsers from '../admin/WhatsAppUsers';
import VisionTechContactPage from '../userDashboard/VisionTechContactPage';
import VisionTechCertificates from '../userDashboard/VisionTechCertificates';
import ContactViewer from '../userDashboard/ContactViewer';

import Admin from '../admin/Admin';
import AdminLogin from '../admin/AdminLogin';
import SpaceAdminPortal from '../admin/SpaceAdminPortal';
import Packages from '../userDashboard/Packages';
import MaintenanceMessage from '../component/MaintenanceMessage';




function AdminAuthenticatedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [checkingRole, setCheckingRole] = React.useState(true);

  React.useEffect(() => {
    const verifyAdminRole = async () => {
      if (isAuthenticated) {
        try {
          const role = await checkUserRole();
          setIsAdmin(role === 'ADMIN');
        } catch (error) {
          console.error('Error verifying admin role:', error);
          setIsAdmin(false);
        }
      }
      setCheckingRole(false);
    };

    verifyAdminRole();
  }, [isAuthenticated]);

  if (isLoading || checkingRole) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/main/login/1/main/1" />;
  }

  if (!isAdmin) {
    return <Navigate to="/home" replace />;
  }

  return children;
}

function AuthenticatedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return children;
  } else {
    return <Navigate to="/login" />;
  }
}

export default function AppRoutes() {


  return (
    <div>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Auth />} />
             <Route path="/login" element={<Auth />} />
            <Route path="/contact-us" element={<VisionTechContactPage />} />
            <Route path="/certifications" element={<VisionTechCertificates />} />
            <Route path="/marketplace" element={<ContactViewer />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path='/admin/main/login/1/main/1' element={ <AdminLogin /> } />
            <Route path="/whatsapp" element={<WhatsAppUsers />} />
            <Route path="/signup" element={<Auth />} />
            <Route path='/forgot-password' element={ <ForgotPassword /> } />
            <Route path='/reset-password' element={<ResetPassword /> } />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path='/verified' element={ <EmailVerified /> } />
            <Route path='/verification-failed' element={ <EmailVerificationFailed /> } />
            <Route path="/home" element={<AuthenticatedRoute><Home /></AuthenticatedRoute>} />
            <Route path="/team" element={<AuthenticatedRoute><Team /></AuthenticatedRoute>} />
            <Route path="/me" element={<AuthenticatedRoute><Me /></AuthenticatedRoute>} />
            <Route path="/packages" element={<AuthenticatedRoute><Packages /></AuthenticatedRoute>} />
            <Route path="/order" element={<AuthenticatedRoute><Order /></AuthenticatedRoute>} />
            <Route path="/proof" element={<AuthenticatedRoute><Proof /></AuthenticatedRoute>} />

            {/* Admin route with special protection */}
            <Route 
              path="/main/admin/dashboard/main/1" 
              element={
                <AdminAuthenticatedRoute>
                  <Admin />
                </AdminAuthenticatedRoute>
              } 
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
